/***
*
*   ACCOUNT
*   Index page for account functions
*
**********/

import React, { useContext } from 'react';
import { AuthContext, Animate, Users, Message } from 'components/lib';
import FirmNav from './nav';

export function FirmUsers(props){

  const context = useContext(AuthContext);
  
  return (
    <Animate>
      {/* Profile Section */}
      
      <FirmNav />
      { (context.permission?.owner || context.permission?.admin) &&
      <> 

      <Message
        title={"Below is a list of all users connected to your firm. This includes all users that have access to all your clients, as well as people that only have access to indivisual client accounts."}
        text={"Adding a user here will give them access to all clients. If you want to add a user to a specific client, you can do that in the client settings."}
        type={'info'}
        >
      </Message>

      <Users showFirmUsers={true} />
      </> 
      }
      
    </Animate>
  )
}